<template>
  <div id="helpMenuWrapper">
    <div id="helpButtonGroup">
      <a :href="helpCenterLink"
         target="_blank"
         data-tooltip="Have questions? Go to our NEW help center"
         data-position="right center"
         data-inverted="">
        <i class="ui dwhite big question circle outline icon"/>
      </a>
      <a @click.stop.prevent="openHelpModal('second')"
         @click.alt.meta.prevent="dvlprmd"
         data-tooltip="Contact us or report an issue"
         data-position="right center"
         data-inverted="">
        <i class="ui dwhite big bug icon"></i>
      </a>
      <a @click.stop.prevent="openHelpModal('third')"
         data-tooltip="Suggest a new feature"
         data-position="right center"
         data-inverted="">
        <i class="ui dwhite big lightbulb outline icon"></i>
      </a>
    </div>
    <HelpModal ref="helpModal"/>
  </div>
 
</template>

<script>
import $ from 'jquery'
import HelpModal from './HelpModal'

export default {
  name: 'HelpMenu',
  components: {
    HelpModal
  },
  data () {
    return {
      isModalOpen: false,
      helpCenterLink: 'https://help.sentrykit.com/'
    }
  },
  methods: {
    dvlprmd: function () { $('.stts21kdfslds').removeClass('stts21kdfslds') },
    // TODO: upgrade semantic to simplify logic
    openHelpModal: function (i) {
      $('#helpModal').modal({
        centered: false,
        onShow: () => {
          $('.ui.dimmer.modals').css({
            'backdrop-filter': 'blur(2px)',
            'background-color': 'rgba(0, 0, 0, 0.3)'
          })
          this.isModalOpen = true
        },
        onHidden: () => {
          this.isModalOpen = false
          this.$refs.helpModal.resetState()
          $('.ui.dimmer.modals').css({
            'background-color': '',
            'backdrop-filter': ''
          })
        }
      }).modal('show').find('.item').tab('change tab', i)
    },
  }
}
</script>

<style scoped>

#helpButtonGroup {position: absolute; top: 5%; left: 20px; z-index: 3;}
#helpButtonGroup a {margin-bottom: 9px; display:block;}
#helpButtonGroup a:hover i {color:yellow;}
#helpButtonGroup a i {text-shadow:#333 0 0 13px;}

</style>



// WEBPACK FOOTER //
// HelpMenu.vue?1b49c190